import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Nosotros } from './components/Nosotros';
import { Membresias } from './components/Membresias';
import { Servicios } from './components/Servicios';
import { HorariosBanner } from './components/HorariosBanner';
import { Galeria } from './components/Galeria';
import { Testimonios } from './components/Testimonios';
import { Contacto } from './components/Contacto';
import { Footer } from './components/Footer';
import { FloatingWhatsApp } from './components/FloatingWhatsApp';
export function App() {
  return <div className="w-full min-h-screen bg-deepblack" data-id="element-0">
      <Navbar data-id="element-1" />
      <Hero data-id="element-2" />
      <Nosotros data-id="element-3" />
      <Servicios data-id="element-4" />
      <Membresias data-id="element-5" />
      <HorariosBanner data-id="element-6" />
      <Galeria data-id="element-7" />
      <Testimonios data-id="element-8" />
      <Contacto data-id="element-9" />
      <Footer data-id="element-10" />
      <FloatingWhatsApp data-id="element-11" />
    </div>;
}